var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.obj.description || _vm.obj.branch)?_c('span',[(_vm.prefix)?_c('span',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(" "),(_vm.obj.description)?_c('span',[_vm._v(_vm._s(_vm.obj.description))]):_vm._e(),_vm._v(" "),(!_vm.obj.description)?_c('span',[_vm._v(_vm._s(_vm.obj.branch))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1280a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/description.vue
// module id = EHW5
// module chunks = 0